<template>
  <el-popover width="540" ref="popperWrapper" popper-class="board-share-popper" trigger="click">
    <div class="content">
      <div class="item">
        <div class="label">分享链接</div>
        <el-input class="value link" disabled :value="shareLink"></el-input>
        <span class="operation" @click="copy">复制链接和密码</span>
      </div>
      <div class="item other">
        <div class="label">密码访问</div>
        <div class="value">
          <el-switch :value="share.password !== null" @input="changePassword"></el-switch>
          <div class="reset" v-if="share.password">
            <div class="password">密码：{{ share.password }}</div>
            <span class="operation" @click="resetPassword">重置密码</span>
          </div>
        </div>
      </div>
      <div class="item other">
        <div class="label">有效期</div>
        <div class="value">
          <el-radio-group :value="share.expiresAt === null" @input="changeExpiration">
            <el-radio :label="true">永久</el-radio>
            <el-radio :label="false">有效期至</el-radio>
          </el-radio-group>
          <el-date-picker
            v-if="share.expiresAt !== null"
            v-model="share.expiresAt"
            type="datetime"
            placeholder="选择日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            default-time="23:59:59"
            class="date"
          ></el-date-picker>
        </div>
        <span class="operation"></span>
      </div>
    </div>
    <template slot="reference">
      <slot name="reference"></slot>
    </template>
  </el-popover>
</template>
<script>
import { copyToClipBoard, randomString } from "@/utils/common"
import { getDashboardShare, upsertDashboardShare } from "@/api/appManage/statistics"
import dj from "dayjs"

export default {
  name: "board-share-popper",
  props: {
    board: Object
  },
  data() {
    return {
      share: {}
    }
  },
  computed: {
    shareLink() {
      return (
        window.location.origin +
        "/board/share/" +
        this.board.id +
        "/" +
        this.share.id +
        "/" +
        encodeURI(this.board.name) +
        " 【" +
        this.board.name +
        "】" +
        (this.share.password ? " 密码：" + this.share.password : "") +
        (this.share.expiresAt ? " 链接有效期至 " + this.share.expiresAt : "")
      )
    }
  },
  watch: {
    "share.password": {
      handler(newVal, oldVal) {
        if (oldVal !== undefined && newVal !== oldVal) upsertDashboardShare(this.share)
      }
    },
    "share.expiresAt": {
      handler(newVal, oldVal) {
        if (oldVal !== undefined && newVal !== oldVal) upsertDashboardShare(this.share)
      }
    }
  },
  created() {
    this.getShare()
  },
  methods: {
    copy() {
      copyToClipBoard(this.shareLink)
      this.$message.success("复制成功")
    },
    async getShare() {
      let share = await getDashboardShare(this.board.id)
      if (share !== undefined) this.share = share
      else
        this.share = await upsertDashboardShare({
          dashboardId: this.board.id
        })
      if (!this._.keys(this.share).includes("password")) this.$set(this.share, "password", null)
      if (!this._.keys(this.share).includes("expiresAt")) this.$set(this.share, "expiresAt", null)
    },
    changePassword(val) {
      this.share.password = val ? randomString(6) : null
    },
    resetPassword() {
      this.share.password = randomString(6)
    },
    changeExpiration(val) {
      this.share.expiresAt = val
        ? null
        : dj()
            .add(3, "d")
            .endOf("d")
            .format("YYYY-MM-DD HH:mm:ss")
    }
  }
}
</script>

<style lang="scss">
.board-share-popper {
  .content {
    margin-top: 20px;
    padding: 0 15px;
    .operation {
      color: #198afa;
      cursor: pointer;
      width: 100px;
      margin-left: 20px;
    }
    .other {
      align-items: flex-start !important;
    }
    .item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .label {
        width: 80px;
        flex-shrink: 0;
      }
      .value {
        flex: 1;
      }
      .reset {
        display: flex;
        align-items: center;
        margin-top: 15px;
        .password {
          flex: 1;
          background-color: #f5f7fa;
          border-radius: 4px;
          border: 1px solid #e4e7ed;
          padding: 0 15px;
          height: 32px;
          display: flex;
          align-items: center;
        }
      }
      .date {
        margin-top: 15px;
        width: 100%;
      }
    }
    .link {
      .el-input__inner {
        color: #606266;
      }
    }
  }
}
</style>
